import { View, Pill, Spinner, Flex, Text } from '@smarterservices/smarter-ui';
import { capitalizeFirstLetter } from '@instructure/ui-utils';
import {
  getStore,
  usePlayerStore,
} from '../../../stores/StoreContext';
import Webrtc from './Webrtc';
import Hls from './Hls';
import { memo } from 'react';
import './VideoContainer.css';
import Disconnected from './Disconnected';
import CONSTANTS from '../../../config/constants';

const VideoContainer = ({
  SessionTrack,
  isFocusedTrack = false,
  trackStatus = 'connected', // can be connected, disconnected, or null
  width = '250px',
  height = '250px',
}) => {
  const PlayerStore = getStore('playerStore');
  const activeVideoSource = usePlayerStore((state) => state.activeVideoSource);
  const displayVideoLabels = usePlayerStore((state) => state.displayVideoLabels);

  if (!SessionTrack) return null;

  const handleClick = () => {
    // Only change focus if this isn't already the focused track
    if (PlayerStore.focusedTrackId !== SessionTrack.id) {
      PlayerStore.focusTrack(SessionTrack.id);
    }
  };

  return (
    <View
      as="div"
      position="relative"
      className="video-container"
      background='brand'
      withVisualDebug={false}
      cursor={!isFocusedTrack ? 'pointer' : 'default'}
      onClick={handleClick}
      width={width}
      height={height}
      themeOverride={{
        backgroundBrand: '#2e3c46'
      }}

    >
      <>
        {trackStatus === 'connected' ? (
          <>
            {activeVideoSource === CONSTANTS.VIDEO_SOURCES.LIVE ? (
              <Webrtc
                SessionTrack={SessionTrack}
              />
            ) : (
              <Hls
                SessionTrack={SessionTrack}
                isFocusedTrack={isFocusedTrack}
                width={width}
                height={height}
              />
            )}
          </>
        ) : (
          <Disconnected />
        )}

        {displayVideoLabels === 'show' && (
          <View as="div" className="video-label">
            <Pill
              color="primary"
              className="video-label"
              themeOverride={{
                background: 'rgba(0,0,0,1)',
                primaryColor: 'rgb(230, 230, 230)',
                textFontSize: '10px',
              }}
            >
              {capitalizeFirstLetter(SessionTrack.name)}
            </Pill>
          </View>
        )}
      </>
    </View>
  );
};

// Memoize the VideoContainer component to prevent unnecessary re-renders
const MemoizedVideoContainer = memo(VideoContainer, (prevProps, nextProps) => {
  // Return true if passing nextProps to render would return
  // the same result as passing prevProps to render,
  // otherwise return false
  return (
    prevProps.SessionTrack?.id === nextProps.SessionTrack?.id &&
    prevProps.isFocusedTrack === nextProps.isFocusedTrack &&
    prevProps.trackStatus === nextProps.trackStatus &&
    prevProps.width === nextProps.width &&
    prevProps.height === nextProps.height
  );
});

export default MemoizedVideoContainer;
